export default __webpack_public_path__ + "public/assets/images/4833df3ea189a7c4f3eac05f4a47247d.png";